import { render } from "./TheMarketList.vue?vue&type=template&id=fd3adeec&scoped=true&ts=true"
import script from "./TheMarketList.vue?vue&type=script&lang=ts"
export * from "./TheMarketList.vue?vue&type=script&lang=ts"

import "./TheMarketList.vue?vue&type=style&index=0&id=fd3adeec&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3adeec"]])

export default __exports__